import {CycleCountItemResponse} from "./CycleCountItemResponse";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

export class CycleCountRemainingItem {

  SKU: string;
  Desc: string;
  QtyOnHand: number;
  UPCs: string;
  EPCs: string;

  QtyOnHandObservable: Observable<number>;
  QtyOnHandObserver: Observer<number>;

  constructor(SKU?: string, Desc?: string, QtyOnHand?: number, UPCs?: string, EPCs?: string) {
    this.SKU = SKU;
    this.Desc = Desc;
    this.QtyOnHand = QtyOnHand;
    this.UPCs = UPCs;
    this.EPCs = EPCs;
  }

  fromCycleCountItemResponse(itemResponse: CycleCountItemResponse): CycleCountRemainingItem{
    this.SKU = itemResponse.SKU;
    this.Desc = itemResponse.Desc;
    this.QtyOnHand = Number(itemResponse.QtyOnHand);
    this.EPCs = itemResponse.EPC;
    this.UPCs = itemResponse.UPC;
    return this.initObservables();
  }

  initObservables(): CycleCountRemainingItem {
    this.QtyOnHandObservable = new Observable(observer => {
      this.QtyOnHandObserver = observer;
      this.QtyOnHandObserver.next(this.QtyOnHand);
    });
    return this;
  }

  // Used only for initializing Geiger mode (only EPC is needed)
  fromSingleEpc(epc: string) {
    this.SKU = '';
    this.Desc = '';
    this.QtyOnHand = 0;
    this.EPCs = epc;
    this.UPCs = '';
    return this;
  }

  clone() {
    return new CycleCountRemainingItem(this.SKU, this.Desc, this.QtyOnHand, this.UPCs, this.EPCs);
  }
}



// WEBPACK FOOTER //
// ./src/models/CycleCountRemainingItem.ts